const Divider = () => {
    return (
        <>
          <div className="row">
            <div className="col-12">
              <hr />
            </div>
          </div>
        </>
    )
}

export default Divider